import type { EntityStatus } from '@mnc/contracts';

/** URL state of the entity directory. */
export interface EntitySearch {
  q?: string;
  status?: EntityStatus;
  attention?: '1';
  sort?: string;
  page?: number;
}

const STATUSES = ['planned', 'active', 'paused', 'closed'];
const str = (v: unknown): string | undefined => (typeof v === 'string' && v.trim() ? v : undefined);

export function parseEntitySearch(raw: Record<string, unknown>): EntitySearch {
  const page = Number(raw.page);
  const status = str(raw.status);
  return {
    q: str(raw.q),
    status: status && STATUSES.includes(status) ? (status as EntityStatus) : undefined,
    attention: raw.attention === '1' || raw.attention === 1 || raw.attention === true ? '1' : undefined,
    sort: str(raw.sort),
    page: Number.isInteger(page) && page > 1 ? page : undefined,
  };
}
